import { render, staticRenderFns } from "./staff-sts.vue?vue&type=template&id=423c3517&"
import script from "./staff-sts.vue?vue&type=script&lang=js&"
export * from "./staff-sts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports